export const quickCreationAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }